export default __webpack_public_path__ + "fonts/free-clear.svg";